import { useState } from "react";
import { motion } from "framer-motion";
import Header from "../components/Header";
import HeroSection from "../components/HeroSection";
import AboutSection from "../components/AboutSection";
import VisionSection from "../components/VisionSection";
import TechnologyShowcase from "../components/TechnologyShowcase";
import OpportunitiesSection from "../components/OpportunitiesSection";
import CharterSection from "../components/CharterSection";
import InitiativesSection from "../components/InitiativesSection";
import ContactSection from "../components/ContactSection";
import Footer from "../components/Footer";

const LandingPage = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <div className="min-h-screen bg-stone-50" data-testid="landing-page">
      <Header 
        mobileMenuOpen={mobileMenuOpen} 
        setMobileMenuOpen={setMobileMenuOpen} 
      />
      
      <main>
        <HeroSection />
        <AboutSection />
        <VisionSection />
        <TechnologyShowcase />
        <OpportunitiesSection />
        <CharterSection />
        <InitiativesSection />
        <ContactSection />
      </main>

      <Footer />
    </div>
  );
};

export default LandingPage;
